module.exports = __webpack_public_path__ + "img/mentalpic.2b7b6f3f.png";